<div class="score-container" [class.score-saved]="saved">
  <div class="score-wrapper">
    <label class="score-label" for="nota">Nota:</label>
    <input
      class="score-input"
      type="number"
      min="0"
      max="10"
      name="nota"
      cdkFocusInitial
      [(ngModel)]="nota"
      [disabled]="disabled"
      (input)="notaChanged.emit()"
      (wheel)="$event.preventDefault()"
      (keydown.enter)="validateNota()" />
    <button mat-raised-button color="primary" (click)="validateNota()" [disabled]="disabled" data-faro-user-action-name="salvar-notas">Confirmar</button>
    <span class="score-saved-indicator" *ngIf="saved">✓ Salva</span>
    <span class="score-hint" *ngIf="!saved">(0 a 10)</span>
    <span class="score-hint-bold">Peso {{ peso }}</span>
    <span class="score-hint-bold">{{ getDescricaoTipoProva() }}</span>
  </div>
</div>
